import { styled } from '@mui/material/styles'
import ListeAgent from './ListeAgent'
import RechercheAgent from './RechercheAgent'
import { Progress } from '../Utils/Progress'
import { useFetchContext } from '../../hook/UseFetchContext'
import { Typography } from '@mui/material'

const PREFIX = 'BlocAgent'

const classes = {
  tree: `${PREFIX}-tree`
}

const StyledProgress = styled(Progress)(() => ({
  [`& .${classes.tree}`]: {
    margin: 0,
    padding: 0,
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: '70vh',
    minHeight: '55vh'
  }
}))

export default function BlocAgent() {
  const { state } = useFetchContext()

  return state.agentTotalState.agentsTotal.length > 0 ? (
    <div>
      <Typography
        component="h2"
        variant="subtitle1"
        color="secondary"
        sx={{ textAlign: 'center', my: -1 }}
      >
        Recherche d'un agent
      </Typography>
      <RechercheAgent />
      <div className={classes.tree}>
        <ListeAgent />
      </div>
    </div>
  ) : (
    <StyledProgress texte="Chargement des agents en cours..." />
  )
}
